import { render, staticRenderFns } from "./device-detail.vue?vue&type=template&id=5c394d64&scoped=true"
import script from "./device-detail.vue?vue&type=script&lang=js"
export * from "./device-detail.vue?vue&type=script&lang=js"
import style0 from "./device-detail.vue?vue&type=style&index=0&id=5c394d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c394d64",
  null
  
)

export default component.exports